import { IParams, IValidation } from './types'

export function initialParams(): IParams {
  return { quantity: 1 }
}

export function validate(params: IParams) {
  const { quantity } = params
  const validation: IValidation = {}

  if (quantity > 8 || quantity < 1) {
    validation.quantity = 'Please select the number of attendees'
  }

  return validation
}
